export default function About() {
  return (
    <>
      <div id="about">

      <section className="sec about-open">
        <div className="shell about-grid">
          <div>
            <p className="eyebrow">About PlaySlot</p>
            <h2 className="h-lg" style={{ marginTop: '20px', fontSize: 'clamp(32px, 3.4vw, 48px)', lineHeight: '1' }}>
              We build the software<br />sport <span style={{ color: 'var(--lime)' }}>runs on.</span>
            </h2>
          </div>
          <div className="about-story">
            <p>
              A whiteboard of court times. A phone that rings during peak hours. A spreadsheet for members, another for coaches. That is still how most sports facilities are run &mdash; and it is why courts sit empty on a Tuesday while players are told to call back later.
            </p>
            <p>
              We built PlaySlot the other way round: one platform where a booking, a membership, a coaching session and a payment are the same record, visible to the club and the player at the same moment.
            </p>
          </div>
        </div>
      </section>


      <section className="sec" style={{ paddingTop: '96px' }}>
        <div className="shell about-grid">
          <div>
            <p className="eyebrow">What we believe</p>
            <h2 className="h-md" style={{ marginTop: '16px' }}>Four things we<br />will not move on.</h2>
          </div>
          <div className="principles">
            <div className="principle">
              <span className="n">01</span>
              <div>
                <h3>A booking should take seconds</h3>
                <p>If a player has to call, wait or make an account before seeing a free court, the club has already lost the booking.</p>
              </div>
            </div>
            <div className="principle">
              <span className="n">02</span>
              <div>
                <h3>An empty court is a cost</h3>
                <p>Utilization decides whether a facility survives. Everything we build points at it.</p>
              </div>
            </div>
            <div className="principle">
              <span className="n">03</span>
              <div>
                <h3>Software should disappear</h3>
                <p>The best outcome is staff who never think about the system, and players who only think about the game.</p>
              </div>
            </div>
            <div className="principle">
              <span className="n">04</span>
              <div>
                <h3>The club owns its players</h3>
                <p>Your members are yours. We do not put a marketplace between a club and the people who play there.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      </div>
    </>
  );
}
